var jstz = require('../../../node_modules/jstz/dist/jstz.min.js');
function validatecallpopup(){
    var id2=$.trim($("#phone_number").val());
	var at=$("input[name=AssignType]:checked").val();
	var reason=$.trim($("#reason").val());
	reason = reason.trim();
	var hour=$("#cbhours").val();
	var min=$("#cbmin").val();
	var mer=$("#cbmer").val();
	var ISD_Code =$("#countryCode").val();
	var Call_Time=hour+":"+min+" "+mer;
    var call_date=$("#call_date").val();
    var tz = jstz.determine();	
	var response_text = 'UTC';
	$("#phone_number").closest(".form-group").removeClass("error");
	$("#reason").closest(".form-group").removeClass("error");
	$("#cbhours").closest(".form-group").removeClass("error");
	$("#cbmin").closest(".form-group").removeClass("error");
	if (typeof (tz) !== 'undefined') {	response_text = tz.name(); 	}	
    if(id2=="")
    {
     	$("#phone_number").closest(".form-group").addClass("error");
	}
	else if(id2.length<6 || id2.length>12){
		$("#phone_number").closest(".form-group").addClass("error");
	}
	else if(reason=="")
	{	
		$("#reason").closest(".form-group").addClass("error");
	}
	else if(hour=="")
	{
		$("#cbhours").closest(".form-group").addClass("error");
		
		//$("#cbmer").closest(".form-group").addClass("error");
	}
	else if(min == ""){
		$("#cbmin").closest(".form-group").addClass("error");
	}
    else
    {
      var numbers = /^[0-9]+$/;  
      if(document.getElementById('phone_number').value.match(numbers))  
      {  
      		$("#callback-btn")
            .find("img")
            .removeClass("hide");
      
	       //$('#call_back_data').html('<center><img src="'+DOMAIN_NAME+'/assets/img/loading.gif" alt="Loader" style="width: 50px;height: 33px;"/></center>');
	   		 $.ajax({
	            url: DOMAIN_NAME+'Home/callpopup.php',
	            type: 'GET',
	           	data: 'Mobile_No='+id2+'&AssignType='+at+'&Reason='+encodeURIComponent(reason)+'&Call_Time='+Call_Time+'&call_date='+call_date +'&ISD_Code='+ISD_Code+'&Timezone_Code='+response_text+'&'+window.CSRF_TOKEN_NAME+'='+$("input[name="+window.CSRF_TOKEN_NAME+"]").val(),
	            success: function(data) {
	            	$("#callback-btn")
		            .find("img")
		            .addClass("hide");
		            //$('#call_back_data').html(data);
		            $("#callbackModal").modal('hide');
		            $("#callbackModalSuccess").modal('show');
		            redirecttime();
	            }
	      });

      }  
      else  
      {  
        $("#phone_number_error").removClass("hide");
        document.getElementById('phone_number').focus();  
        return false;  
      }	  
   }
}

function redirecttime()
{
	setTimeout(function(){location.reload();},2000);
}

function isNumberKey(evt){    
	var charCode = (evt.which) ? evt.which : evt.keyCode;    
	if (charCode > 31 && (charCode < 48 || charCode > 57))      
  	return false;   
  	return true;
}

function errorhide(){
    $("#phone_number_error").addClass("hide");
} 

$("#callbackModal").on('hidden.bs.modal', function(){
    $("#callback-form")[0].reset();
    $("#callback-form").find(".form-group").removeClass("error");
});

// Restricts input for each element in the set of matched elements to the given inputFilter.
(function($) {
  $.fn.inputFilter = function(inputFilter) {
    return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function() {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  };
}(jQuery));

$("#phone_number").inputFilter(function(value) {
  return /^-?\d*$/.test(value); });


$(document).on('keyup','#phone_number',function(){
	$("#phone_number").closest(".form-group").removeClass("error");
    var id2=$.trim($("#phone_number").val());
    if(id2=="")
    {
     	$("#phone_number").closest(".form-group").addClass("error");
	}
	else if(id2.length<6 || id2.length>12){
		$("#phone_number").closest(".form-group").addClass("error");
	}
    
});

$(document).on('keyup','#reason',function(){
	$("#reason").closest(".form-group").removeClass("error");
    var reason=$.trim($("#reason").val());
    if(reason=="")
	{	
		$("#reason").closest(".form-group").addClass("error");
	}
    
});

$(document).on('change','#cbhours',function(){
	$("#cbhours").closest(".form-group").removeClass("error");
    var hour=$("#cbhours").val();
    if(hour=="")
	{
		$("#cbhours").closest(".form-group").addClass("error");
	}
    
});

$(document).on('change','#cbmin',function(){
	$("#cbmin").closest(".form-group").removeClass("error");
    var min=$("#cbmin").val();
    if(min == ""){
		$("#cbmin").closest(".form-group").addClass("error");
	}
    
});

$("#callpopupopen").click(function(){
    $('#call_back_data').html('<center><img src="'+DOMAIN_NAME+'assets/img/loading.gif" alt="Loader" style="width: 50px;height: 33px;"/></center>');
    $("#callbackModal").modal('show');
    $.ajax({
        async: true,
        url: DOMAIN_NAME+"Home/front-popnew-homenew-uk.php",
        success: function (data) {
            $('#call_back_data').html(data);
            //$("#callbackModal").modal('show');
            $("#phone_number").inputFilter(function(value) {
  			return /^-?\d*$/.test(value); });
        }
    });
     
});

window.validatecallpopup = validatecallpopup;
window.isNumberKey = isNumberKey;
window.errorhide = errorhide;
window.redirecttime = redirecttime;